import _ from 'lodash';
import angular from 'angular';

import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.order',
    modules: [
        R,
    ],
})
@Service('OrderStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('orders');
        this.resetParams()
    }

    resetParams () {
        this.params = angular.copy(this.defaultParams || {});
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/order.js